// filtri/accesso.ts — chi può usare quale filtro. Puro: si prova con node:test.
// Regole (SPECIFICA-CONCORDATA §6, §9): base per tutti; silver con Silver o Gold; esclusivi se comprati con i
// crediti, oppure con Gold quando app.gold_filtri_esclusivi è acceso (decisione del 23 ottobre 2026) — tranne quelli
// «solo con i crediti» (filtri.solo_crediti, all'inizio quelli da 500 e 1000): un premio per chi fa crescere l'app.
import type { PianoFiltro } from "./tipi.ts";

export type PianoUtente = "base" | "silver" | "gold";

export interface ProfiloFiltri {
  piano: PianoUtente;
  /** id dei filtri comprati con i crediti (esclusivi e, dalla v030, anche Silver) */
  posseduti: ReadonlySet<string>;
  /** Modalità di prova (v008): il tester prova tutti i filtri, anche Silver ed esclusivi. */
  tester?: boolean;
  /** Gold comprende anche gli esclusivi (app.gold_filtri_esclusivi). */
  goldEsclusivi?: boolean;
}

export interface RegolaFiltro {
  id: string;
  piano: PianoFiltro;
  prezzoCrediti: number;
  /** Esclusivo solo con i crediti, anche per Gold. */
  soloCrediti?: boolean;
}

/** "libero" = si può usare; "silver" = serve l'abbonamento; "crediti" = si compra con i crediti. */
export type Accesso = "libero" | "silver" | "crediti";

export function accessoFiltro(f: RegolaFiltro, p: ProfiloFiltri): Accesso {
  if (p.tester) return "libero";
  if (f.piano === "base") return "libero";
  // v030: anche un filtro Silver si può prendere con le stelle: chi l'ha preso lo usa senza abbonamento
  if (f.piano === "silver") return p.piano !== "base" || p.posseduti.has(f.id) ? "libero" : "silver";
  if (p.piano === "gold" && p.goldEsclusivi && !f.soloCrediti) return "libero";
  return p.posseduti.has(f.id) ? "libero" : "crediti";
}

/** Ordine nel selettore: prima quelli usabili, poi Silver, poi gli esclusivi per prezzo; a parità, numero di catalogo. */
export function ordinaPerScelta<T extends RegolaFiltro & { numero: number }>(filtri: readonly T[], p: ProfiloFiltri): T[] {
  const peso = (a: Accesso) => (a === "libero" ? 0 : a === "silver" ? 1 : 2);
  return [...filtri].sort(
    (a, b) => peso(accessoFiltro(a, p)) - peso(accessoFiltro(b, p)) || a.prezzoCrediti - b.prezzoCrediti || a.numero - b.numero,
  );
}
